import { useTheme } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { useWindow } from './useWindow'

export const useBreakpointWidth = () => {
  const theme = useTheme()

  const { innerWidth } = useWindow()

  const breakpoints = useMemo(
    () =>
      Object.values(theme.breakpoints.values).sort((a, b) => (a > b ? -1 : 1)),
    [theme.breakpoints.values],
  )
  const currentBreakpoint = useMemo(
    () => breakpoints.find((bp) => bp <= innerWidth) ?? innerWidth,
    [innerWidth, breakpoints],
  )

  const [width, setWidth] = useState<number>(currentBreakpoint)

  const handleResize = () => {
    setWidth(currentBreakpoint)
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [innerWidth, theme, theme.breakpoints.values])

  return width
}
